import ImagesGrid from "./ImagesGrid";

export default ImagesGrid;